// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ReferenceDataResponse } from './reference-data-response';

/** See com.rev360.pms.api.controller.insurance.PersonInsuranceTableResponse */
/* istanbul ignore next */
@GandalfModel
export class PersonInsuranceTableResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	coPay!: number | null;

	@GandalfProperty({ designType: String })
	companyName!: string | null;

	@GandalfProperty({ designType: String })
	groupNumber!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	policyNumber!: string | null;

	@GandalfProperty({ designType: ReferenceDataResponse })
	priority!: ReferenceDataResponse | null;

	@GandalfConstantDecorator(constants.PersonInsuranceStatus)
	@GandalfProperty({ designType: constants.PersonInsuranceStatus })
	status!: constants.PersonInsuranceStatus | null;

	@GandalfProperty({ designType: ReferenceDataResponse })
	type!: ReferenceDataResponse | null;

}
